import React from "react";
import { FlatList } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { ContactItem } from "./ContactItem";
import { SmsContact } from "../types";

type SmsContactListProps = {
  contacts: SmsContact[];
  onDeleteContact: (id: string) => void;
};

export function SmsContactList({ contacts, onDeleteContact }: SmsContactListProps) {
  const { theme } = useUnistyles();

  const handleDeleteContact = (id: string) => {
    if (window.confirm("Are you sure you want to remove this contact?")) {
      onDeleteContact(id);
    }
  };

  if (contacts.length === 0) {
    return (
      <View flex={1} justifyContent="center" alignItems="center" px="8xl">
        <Text textStyle="md/regular" color="textMuted" textAlign="center" mb="md">
          No SMS contacts added yet
        </Text>
        <Text textStyle="sm/regular" color="textMuted" textAlign="center">
          Tap the + button to add an SMS contact
        </Text>
      </View>
    );
  }

  return (
    <FlatList
      data={contacts}
      keyExtractor={(item, index) => `${item.id}-${index}`}
      renderItem={({ item, index }) => (
        <ContactItem
          title={item.name}
          subtitle={item.phone_number}
          onDelete={() => handleDeleteContact(item.id)}
          testID={`sms-contact-${item.id}`}
          isLastItem={index === contacts.length - 1}
        />
      )}
      contentContainerStyle={{ paddingBottom: theme.spacing["3xl"] }}
    />
  );
}
